export default class QueryAggregationItem
{
	remoteClass = "gongqi.erp.gotmodel.query.QueryAggregationItem";

	tableId;	//String
	fieldId;	//String
	fieldName;	//String
	fieldType;	//String
		
	aggregationType;	//String
	having;	//String

	
	aliasName;
	constValue;
	having2;
	havingAndOr;
}


// WEBPACK FOOTER //
// ./src/query/remote/QueryAggregationItem.js